import { DECISION_TYPE, PaymentMethodForms } from "../../../../../shared/interfaces";
import { DEFAULT_PAYMENT_PLAN_CODE } from "../../../../../shared/services";

export const getValueDefaultPaymentMethod = (paymentMethodsList: Array<PaymentMethodForms>) => {
    const defaultPaymentMethod = paymentMethodsList.find(paymentMethod => paymentMethod.esDefault.toUpperCase() === DECISION_TYPE.YES);

    if(defaultPaymentMethod) return defaultPaymentMethod?.nroPlanDePago;

    if(paymentMethodsList.length) return paymentMethodsList[0]?.nroPlanDePago;

    return '1';
};